import React, { useState } from 'react';
import "./LoginPage.css"; // Reuse existing styles
import { useNavigate, Navigate } from 'react-router-dom';
import Notification from '../../components/Common/Notification';
import functions from '../../util/functions';
import ajaxUser from '../../util/remote/ajaxUser';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const tokenInfo = functions.readUser(); // optional auth check

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [notify, setNotify] = useState(null);
  const [loading, setLoading] = useState(false);

  if (!tokenInfo) {
    return <Navigate to="/login" />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      setNotify(<Notification message="All fields are required." type="danger" />);
      return;
    }

    if (password !== confirmPassword) {
      setNotify(<Notification message="Passwords do not match." type="danger" />);
      return;
    }

    setLoading(true);
    const res = await ajaxUser.resetPassword(password);
    setLoading(false);

    if (res.status === 'OK') {
      setNotify(<Notification message={`${res.message}... Redirecting...`} type="success" />);
      setTimeout(() =>{
        //logout user
        handleLogout();
      }, 3000);
    } else {
      setNotify(<Notification message={res.message} type="danger" />);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('yexp@user');
    navigate('/login');
    window.location.reload();
  };

  return (
    <div className="content">
      <div className="container">
        <div className="row">
          {/* Left Image Section */}
          <div className="col-md-6">
            <div className="text-left mb-4">
              <img
                src="assets/images/logo.svg"
                alt="logo"
                className="logo"
                style={{ maxWidth: "60px", height: "auto", position: 'absolute' }}
              />
            </div>
            <img
              src="assets/images/undraw_remotely_2j6y.svg"
              alt="Illustration"
              className="img-fluid"
            />
          </div>

          {/* Right Form Section */}
          <div className="col-md-6 contents">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="mb-4">
                  <h3>Set New Password</h3>
                  <p className="mb-4">
                    Enter and confirm your new YEXP Accounting System password below.
                  </p>
                </div>

                <form onSubmit={handleSubmit}>
                  {notify}

                  <div className={`form-group first ${password.length > 0 ? 'field--not-empty' : ''}`}>
                    <label htmlFor="password">New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>

                  <div className={`form-group las mb-4 ${confirmPassword.length > 0 ? 'field--not-empty' : ''}`}>
                    <label htmlFor="confirmPassword">Confirm Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="confirmPassword"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </div>

                  <input
                    type="submit"
                    value={loading ? "Processing..." : "Reset Password"}
                    className="btn btn-block btn-primary"
                    disabled={loading}
                  />
                </form>
                <p className="text-left text-mute mt-4" style={{ fontSize: "14px" }}>
                    Already setup your password? <a href="#login" onClick={handleLogout}>Login</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
